import Http from '@/api/http.js'

export default {
  index(filter){
    return Http.get(`/holidays`, {params: {...filter}});
  },
  create(holiday){
    return Http.post(`/holidays`, {
      holiday: {...holiday}
    });
  },
  update(holiday){
    return Http.put(`/holidays/${holiday.id}`, {
      holiday: {...holiday}
    });
  },

  delete(holiday_id){
    return Http.delete(`/holidays/${holiday_id}`);
  },
}